import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { FlexMenuComponent } from './flex-menu';

@NgModule({
  declarations: [
    FlexMenuComponent,
  ],
  imports: [
    IonicModule,
  ],
  exports: [
    FlexMenuComponent
  ]
})
export class FlexMenuComponentModule {}



// WEBPACK FOOTER //
// ./src/components/flex-menu/flex-menu.module.ts